import { render, staticRenderFns } from "./SinglePaymentMethod.vue?vue&type=template&id=12932027&scoped=true&"
import script from "./SinglePaymentMethod.vue?vue&type=script&lang=js&"
export * from "./SinglePaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./SinglePaymentMethod.vue?vue&type=style&index=0&id=12932027&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12932027",
  null
  
)

export default component.exports